import { PageHeader } from "@/components/page-header";
import { DocButton } from "@/components/ui/doc-button";
import { useCustomInstruments } from "@/lib/hooks/use-custom-instruments";
import { useT } from "@/lib/i18n/use-t";
import { CustomInstrumentsLoader } from "./custom-instruments-loader";
import { CustomInstrumentsWrapper } from "./custom-instruments-wrapper";
import { T } from "./page.i18n";

export default function CustomInstruments() {
  const t = useT(T);
  const { instruments, isLoading } = useCustomInstruments();

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={[{ label: t.settings, href: "/settings" }, { label: t.customInstruments }]}
        title={t.customInstruments}
        description={t.description}
        actions={
          <DocButton docSlug="time-series" variant="outline" size="sm">
            {t.documentation}
          </DocButton>
        }
      />

      {isLoading && instruments.length === 0 ? (
        <CustomInstrumentsLoader />
      ) : (
        <CustomInstrumentsWrapper items={instruments} />
      )}
    </div>
  );
}
